import { Box, BoxProps } from '@mui/material';
import { neutral } from '_lex/_foundations/phxColors';
import React from 'react';

interface EditorSheetProps extends BoxProps {
  children: React.ReactNode;
}

const EditorSheet: React.FC<EditorSheetProps> = ({ children, ...props }) => {
  return (
    <Box
      className='editor-sheet'
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: 6,
        py: 8,
        px: 5,
        width: '94%',
        maxWidth: '800px',
        mx: 'auto',
        backgroundColor: neutral[25],
        border: `1px solid ${neutral[200]}`,
        '& > *': { minWidth: 0 },
        ...props.sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default EditorSheet;
